import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { RouteProgress } from './shared/route-progress/route-progress';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouteProgress],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly configured = !!environment.supabaseUrl && !!environment.supabaseKey;

  constructor() {
    // Apply the saved light/dark choice app-wide (incl. the standalone billing
    // and pricing pages that live outside the app shell). '' = follow the OS.
    const theme = localStorage.getItem('dn_theme');
    if (theme === 'light' || theme === 'dark') {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }
}
